import React, { Component } from 'react'
import { usersService } from '../../_services/users.service'
import { Dropdown } from 'semantic-ui-react'


class UserSelectByUnitType extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: this.props.defaultValue,
      data: [],
    };
  }

  componentWillMount() {
    this.getData();
  }

  getData() {
console.log(this.props.userType);

    usersService.getAllByUserType(this.props.userType)
      .then((res) => {
        let data = res.data.map(elm => ({ "text": elm.fullName, "value": elm.id }))
        this.setState({ data: data, loading: false, isSubmitting: false });
      }).catch((error) => {
        // console.log(error)
      });

  };


  async componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.state.defaultValue) {
      this.setState({ defaultValue: nextProps.defaultValue });
    }
  }

  handleChange = (e) => {

    let selected = e;
    this.setState({ selected: selected })
    this.props.onChange(selected)

  }

  render() {

    const { data, loading, defaultValue, disabled } = this.state;
    const { clearable, className, multiple, selection } = this.props;

    return (
      <Dropdown
        noResultsMessage="کاربری یافت نشد"
        placeholder=''
        fluid
        search
        selection
        // basic
        onChange={(e, data) => this.handleChange(data.value)}
        value={defaultValue}
        multiple={multiple}
        selection={selection}
        className={className}
        options={data}
        wrapSelection={false}
        selectOnBlur={false}
        searchInput={{ autoFocus: false }}
        loading={loading}
        disabled={disabled}
        clearable={clearable}
      />
    );
  }
}
export default UserSelectByUnitType;
